<template>
  <Teleport to="body">
    <template v-if="visivel">
      <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable crm-modal-wide">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Configurar colunas</h5>
              <button type="button" class="btn-close" @click="fechar"></button>
            </div>

            <div class="modal-body">
              <div class="mb-4">
                <h6 class="text-uppercase text-muted fs-12 mb-3">Colunas fixas</h6>
                <div v-for="coluna in colunasFixas" :key="coluna.id" class="form-check mb-2">
                  <input
                    :id="`fixa-${coluna.id}`"
                    v-model="selecionadasFixas"
                    class="form-check-input"
                    type="checkbox"
                    :value="coluna.id"
                    :disabled="coluna.obrigatoria"
                  />
                  <label class="form-check-label" :for="`fixa-${coluna.id}`">
                    {{ coluna.label }}
                    <span v-if="coluna.obrigatoria" class="text-muted">(obrigatória)</span>
                  </label>
                </div>
              </div>

              <div>
                <h6 class="text-uppercase text-muted fs-12 mb-3">Campos personalizados</h6>
                <div v-if="!camposPersonalizados.length" class="text-muted small">Nenhum campo ativo disponível.</div>
                <div v-for="campo in camposPersonalizados" :key="campo.id" class="form-check mb-2">
                  <input
                    :id="`custom-${campo.id}`"
                    v-model="selecionadasCustom"
                    class="form-check-input"
                    type="checkbox"
                    :value="campo.id"
                  />
                  <label class="form-check-label" :for="`custom-${campo.id}`">{{ campo.nome_exibicao }}</label>
                </div>
              </div>
            </div>

            <div class="modal-footer justify-content-between">
              <BButton variant="ghost-secondary" @click="restaurarPadrao">Restaurar padrão</BButton>
              <div class="d-flex gap-2">
                <BButton variant="ghost-dark" @click="fechar">Cancelar</BButton>
                <BButton variant="success" @click="salvar">Salvar</BButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" @click="fechar"></div>
    </template>
  </Teleport>
</template>

<script>
export default {
  name: 'GridContatoColunasSelector',
  props: {
    visivel: { type: Boolean, default: false },
    colunasFixas: { type: Array, default: () => [] },
    camposPersonalizados: { type: Array, default: () => [] },
    selecionadas: {
      type: Object,
      default: () => ({ fixas: [], personalizadas: [] }),
    },
  },
  emits: ['fechar', 'salvar'],
  data() {
    return {
      selecionadasFixas: [],
      selecionadasCustom: [],
    };
  },
  watch: {
    selecionadas: {
      immediate: true,
      deep: true,
      handler(value) {
        this.selecionadasFixas = [...(value?.fixas || [])];
        this.selecionadasCustom = [...(value?.personalizadas || [])];
      },
    },
    visivel(value) {
      if (value) {
        this.selecionadasFixas = [...(this.selecionadas?.fixas || [])];
        this.selecionadasCustom = [...(this.selecionadas?.personalizadas || [])];
      }
    },
  },
  methods: {
    restaurarPadrao() {
      this.selecionadasFixas = this.colunasFixas.filter((coluna) => coluna.padrao || coluna.obrigatoria).map((coluna) => coluna.id);
      this.selecionadasCustom = [];
    },
    salvar() {
      this.$emit('salvar', {
        fixas: this.colunasFixas
          .filter((coluna) => coluna.obrigatoria || this.selecionadasFixas.includes(coluna.id))
          .map((coluna) => coluna.id),
        personalizadas: this.selecionadasCustom.map((id) => Number(id)),
      });
    },
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1040;
}

.crm-modal-wide {
  max-width: min(1200px, calc(100vw - 1rem));
}
</style>
